export default __webpack_public_path__ + "955577117a5af002e2d46582b3c26d96.png";